import { embeds } from 'variables'

const handlers = []
export default function textToBlock(text) {
  // doesn't look like a url at all - just make a text block
  if (!text.match(/^https?:\/\//)) return //createTextBlock(text)

  const handler = handlers.find(({ patterns }) =>
    patterns.some(pattern => text.match(pattern))
  )

  if (handler) return handler.process(text)

  // fallback to text block
  // return createTextBlock(text)
}

const oembed = embed => async text => {
  // use noembed or custom oembed?
  const oembed = embed.oembed
    ? embed.oembed
    : url => 'https://noembed.com/embed?url=' + url

  const url = embed.processUrl ? embed.processUrl(text) : text

  const data = await fetch(oembed(encodeURIComponent(url))).then(r => r.json())

  if (!data.html || !data.provider_url) {
    alert('There was a problem accessing this link.')
    console.error('Bad oembed', data)
    return
    // return createTextBlock(text)
  }

  if (embed.processData) {
    embed.processData(data)
  }

  const aspect = data.aspect === null ? null : data.height / data.width
  return {
    embed: data,
    aspect: aspect || null,
    height: aspect ? null : 10,
    name: data.title || data.provider_name || ''
  }
}

Object.values(embeds).forEach(embed =>
  handlers.push({
    patterns: embed.urlPatterns,
    process: oembed(embed)
  })
)

handlers.push({
  // https://res.cloudinary.com/designstudio/video/upload/q_95,w_1600,c_fill,vc_auto/api/Case_study_assets/Stake2/STAKE_LOGO_LOOP_Fast_1a.mp4
  // https://storage.googleapis.com/spec-host-backup/mio-design%2Fassets%2F1G2_sgtb_rA15LogDDRQJ0UZk5k6f7Ib5%2F03-tone-v2.mp4
  patterns: [/\.(mp4|mov)(\?.*)?$/],
  process: async text => ({
    video: text,
    height: 8,
    name: ''
  })
})

handlers.push({
  patterns: [/https?:\/\/canvas.p22.studio\/?.*/],
  process: async url => ({
    embed: {
      html: `<iframe scrolling="no" frameborder="no" src="${url}"></iframe>`,
      provider_url: url,
      provider_name: 'iframe'
    },
    height: 10,
    name: ''
  })
})

export function createTextBlock(text) {
  return {
    name: 'Text',
    text: {
      text,
      align: 'left',
      color: 'black',
      size: 0.6
    },
    height: 0
  }
}
